/** Parse a server-sent-events response body into typed JSON events. */
export async function* parseSSEStream<T>(response: Response): AsyncGenerator<T> {
  const body = response.body;
  if (!body) throw new Error('Response has no body');
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });

      let sep: number;
      while ((sep = buffer.indexOf('\n\n')) !== -1) {
        const block = buffer.slice(0, sep);
        buffer = buffer.slice(sep + 2);

        // Each block may contain multiple `data:` lines; we only emit the last
        // JSON payload (the server only ever sends one).
        for (const line of block.split('\n')) {
          if (!line.startsWith('data:')) continue;
          const raw = line.slice(5).trim();
          if (!raw) continue;
          try {
            yield JSON.parse(raw) as T;
          } catch (err) {
            console.warn('SSE parse error for line:', raw, err);
          }
        }
      }
    }
  } finally {
    reader.releaseLock();
  }
}
